// src/api/collectionApi.ts
import { http } from "../services/http"; // axios instance có baseURL + token nếu cần

// ===== TYPES =====
export type DropNavDto = {
  id: number;
  slug: string;
  name: string;
  era?: string;
  season?: string;
  sortOrder?: number;
};

export type DropDetailDto = {
  id: number;
  slug: string;
  name: string;
  description?: string;
  shortDesc?: string;
  season?: string;
  heroImageUrl?: string;
  featuredImageUrl?: string;
  storyTitle?: string;
  storyBody?: string;
};

export type DropDetailResponse = {
  collection: DropDetailDto | null;
  products: any[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
};

// ===== API =====

// Nav tabs (list drop)
export async function getDropsNav(params: {
  era?: string;
  isActive?: boolean;
}) {
  const res = await http.get<DropNavDto[]>("api/Collections/drops", { params });
  return res.data;
}

// Detail drop theo slug
export async function getDropDetail(
  slug: string,
  params: { page?: number; pageSize?: number; sort?: string }
) {
  const res = await http.get<DropDetailResponse>(
    `/api/Collections/${encodeURIComponent(slug)}`,
    { params }
  );
  return res.data;
}

// (OPTIONAL) Lấy drop mới nhất theo era
export async function getLatestDrop(params: {
  era?: string;
  page?: number;
  pageSize?: number;
  sort?: string;
}) {
  const res = await http.get<DropDetailResponse>(
    "/api/Collections/drops/latest",
    { params }
  );
  return res.data;
}
